import { onSnapshot } from 'firebase/firestore';

// Wraps onSnapshot with exactly one retry on permission-denied. Firestore's
// listen stream can race Firebase Auth's token attachment right as a
// session is restored on page load - even when a caller waits for its own
// user?.uid state to be set before subscribing, the very first subscribe
// attempt can still go out a beat before the ID token is actually attached
// to the request. Unlike a plain getDoc, a listener that gets
// permission-denied is terminal (Firestore never retries it on its own once
// auth catches up a moment later), so this gives it one retry after a brief
// wait before treating it as a real, final error.
export function subscribeWithRetry(getRef, onNext, onFinalError) {
  let cancelled = false;
  let retried = false;
  let unsubscribe = () => {};

  const attempt = () => {
    unsubscribe = onSnapshot(getRef(), onNext, (error) => {
      if (cancelled) return;
      if (!retried && error?.code === 'permission-denied') {
        retried = true;
        setTimeout(() => { if (!cancelled) attempt(); }, 400);
        return;
      }
      onFinalError(error);
    });
  };
  attempt();

  return () => {
    cancelled = true;
    unsubscribe();
  };
}
